<template lang="pug">
.privacy-policy
  .content
    vue-markdown(:linkify="false") {{ content }}
  Footer.footer(:white="true")
</template>

<script>
import VueMarkdown from 'vue-markdown'
import content from '@/assets/privacy-policy.md'
import Footer from './../home/Footer'

export default {
  name: 'PrivacyPolicy',
  components: {
    VueMarkdown,
    Footer
  },
  data: () => ({
    content
  })
}
</script>

<style lang="scss" scoped>
@use '@/styles/colors';

.privacy-policy {
  width: 100%;
  min-height: 100vh;
  overflow: auto;
  color: white;
  background-image: linear-gradient(
    100deg,
    colors.$intense-purple,
    colors.$light-purple-gradient
  );

  .content {
    max-width: 80%;
    padding-top: 30px;
    margin: auto;
  }
}
</style>

<style lang="scss">
@use '@/styles/text';

h1 {
  @include text.title;
  text-align: left;
  font-size: 25px;
}

h2 {
  @include text.subtitle;
  text-align: left;
  font-size: 22px;
}

h3 {
  @include text.subtitle;
  text-align: left;
  font-size: 18px;
}
</style>
